const toCookies = {
  id: '__id__',
  fullname: '__name__',
  email: '__mail__',
  picture: '__pic__',
  companyId: '__co__',
  companyName: '__c_name__',
  companyEmail: '__c_email__',
  isActive: '__ac__',
  role: '__role__',
  userTitle: '__ut__',
  agencyId: '__ag__',
  isAgency: '__ia__',
  permissions: '__per__',
  method: '__ms__',
  isOnboarding: '__ob__',
  orgPositionId: '__org_pos__',
  csrfToken: '__c_token__'
}

const fromCookies = {
  __id__: 'id',
  __name__: 'fullname',
  __mail__: 'email',
  __pic__: 'picture',
  __co__: 'companyId',
  __c_name__: 'companyName',
  __c_email__: 'companyEmail',
  __ac__: 'isActive',
  __role__: 'role',
  __ut__: 'userTitle',
  __ag__: 'agencyId',
  __ia__: 'isAgency',
  __per__: 'permissions',
  __ms__: 'method',
  __ob__: 'isOnboarding',
  __org_pos__: 'orgPositionId',
  __c_token__:'csrfToken'
}

export default function cookiesToObject(cookies) {
  const cookiesObject = {}

  if (!cookies) return cookiesObject

  cookies.split('; ').forEach((cookie) => {
    const [cookiesKey, value] = cookie.split('=')
    const key = fromCookies[cookiesKey]

    if (!key) return

    if (value === 'null') {
      cookiesObject[key] = null
    } else if (value === 'false' || value === 'False') {
      cookiesObject[key] = false
    } else if (value === 'true' || value === 'True') {
      cookiesObject[key] = true
    } else if (key === 'permissions') {
      cookiesObject[key] = value.replaceAll('\\054', ',')
    } else {
      cookiesObject[key] = value.replaceAll('"', '')
    }
  })

  return cookiesObject
}

export function deleteAllCookies() {
  const cookies = document.cookie.split(';')
  // eslint-disable-next-line no-const-assign, no-plusplus
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
  }
}

export function addCookie(key, value) {
  document.cookie = `${toCookies[key]}=${value};path=/`
}

const AGENCY_TYPE_CACHE_KEY = 'agencyTypeCache'

export function clearAgencyTypeCache() {
  localStorage.removeItem(AGENCY_TYPE_CACHE_KEY)
}

export function getCookie(key) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}